
import React from 'react';
import { useParentAccessRequests } from '@/hooks/useParentAccessRequests';
import { useAuth } from '@/contexts/AuthContext';
import ParentAccessRequestAlert from '@/components/notifications/ParentAccessRequestAlert';

const ParentAccessRequestsBanner: React.FC = () => {
  const { profile } = useAuth();
  const { requests, loading, refreshRequests } = useParentAccessRequests();

  // Only show for athletes with pending requests
  if (!profile || profile.role !== 'athlete' || loading || requests.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {requests.map((request) => (
        <ParentAccessRequestAlert
          key={request.id}
          request={request}
          onResponse={refreshRequests}
        />
      ))}
    </div>
  );
};

export default ParentAccessRequestsBanner;
